import { Box, styled } from '@mui/material';
import { Column, Row } from 'components/Layout';

type Props = {
  icon: React.ReactNode;
  primaryLabel: React.ReactNode;
  secondaryLabel: React.ReactNode;
  actions: React.ReactNode;
};

const Card = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(
    theme.spacingSizes.sm,
    theme.spacingSizes.xl,
    theme.spacingSizes.sm,
    theme.spacingSizes.sm,
  ),
  justifyContent: 'space-between',
  alignItems: 'center',
  alignSelf: 'stretch',
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.shape.borderRadius,
}));

const PeriodCard: React.FC<Props> = ({
  icon,
  primaryLabel,
  secondaryLabel,
  actions,
}) => {
  return (
    <Card>
      <Column spacing="lg">
        <Row centered spacing="xs">
          {icon}
          {primaryLabel}
        </Row>
        {secondaryLabel}
      </Column>
      {actions}
    </Card>
  );
};

export default PeriodCard;
